import { api } from "./api"
import type { ActiveSession, AuthResponse, LoginRequest, RegisterRequest, User } from "@/types/auth"

export const authService = {
  login: (data: LoginRequest) =>
    api.post<AuthResponse>("/auth/login", data).then((r) => r.data),

  register: (data: RegisterRequest) =>
    api.post<AuthResponse>("/auth/register", data).then((r) => r.data),

  logout: () =>
    api.post("/auth/logout").catch(() => { /* ignore errors on logout */ }),

  me: () => api.get<User>("/auth/me").then((r) => r.data),

  // 2FA
  setup2fa: () =>
    api.post<{ secret: string; otpAuthUri: string }>("/auth/2fa/setup").then((r) => r.data),

  enable2fa: (code: string) =>
    api.post("/auth/2fa/enable", { code }).then((r) => r.data),

  disable2fa: (code: string) =>
    api.post("/auth/2fa/disable", { code }).then((r) => r.data),

  verifyTwoFactor: (twoFactorToken: string, code: string) =>
    api.post<AuthResponse>("/auth/2fa/verify", { twoFactorToken, code }).then((r) => r.data),

  updateProfile: (data: { name: string; monthlyIncome?: number | null; currency: string }) =>
    api.put<User>("/settings/profile", data).then((r) => r.data),

  changePassword: (data: { currentPassword: string; newPassword: string }) =>
    api.put("/settings/password", data),

  logoutAll: () =>
    api.post("/settings/logout-all"),

  sessions: () =>
    api.get<ActiveSession[]>("/settings/sessions").then((r) => r.data),

  revokeSession: (id: string) =>
    api.delete(`/settings/sessions/${id}`),

  forgotPassword: (email: string) =>
    api.post("/auth/forgot-password", { email }),

  resetPassword: (token: string, newPassword: string) =>
    api.post("/auth/reset-password", { token, newPassword }),

  verifyEmail: (token: string) =>
    api.get(`/auth/verify-email?token=${encodeURIComponent(token)}`),

  resendVerification: (email: string) =>
    api.post("/auth/resend-verification", { email }),
}
